import { create } from "zustand";

interface InitialState {
    loading: boolean;
}
interface Actions {
    setLoading(loading: boolean): void;
}

const useGlobalSpinner = create<InitialState & Actions>(set => ({
    loading: false,
    setLoading: loading => set({ loading }),
}));

export default useGlobalSpinner;
